/* global Swiper */
import helpers from '../../util/helpers';
import * as constants from '../../util/constants';

export default {
  init() {
    //
  },
  finalize() {
    const header = $('header');
    const body = $('body');
    const r = document.querySelector(':root');

    if (header.length) {
      const headerHeight = 90;
      let lastScroll = $(window).scrollTop();

      helpers.onWindowEvents(() => {
        let scrollTop = $(window).scrollTop();

        // Passed header height
        if (scrollTop > headerHeight) {
          header.addClass('scroll-beyond');
        } else {
          header.removeClass('scroll-beyond');
        }

        // Refocus header on scroll up (only when scrolled beyond header height)
        if ($(window).scrollTop() >= headerHeight) {
          if (lastScroll - scrollTop < 0) {
            // Scrolled up
            header.removeClass('scroll-beyond-refocus');
          } else if (lastScroll - scrollTop > 0) {
            // Scrolled down
            header.addClass('scroll-beyond-refocus');
          }
        } else {
          header.removeClass('scroll-beyond-refocus');
        }
        lastScroll = $(window).scrollTop();
      }, 1, 1, 1, 1);

      $('.select-hotel-btn').on('click', function () {
        body.toggleClass('select-hotel-open');
      });

      $('li.menu-item').on('mouseover', function () {
        let menuItem = $(this);
        let submenuWrapper = $('> .sub-menu', menuItem);

        // grab the menu item's position relative to its positioned parent
        let menuItemPos = menuItem.position();
        let adminBarHeight =  header.hasClass('scroll-beyond') || !body.hasClass('transparent-header') ? $('#wpadminbar').outerHeight() : 0 ;

        // place the submenu in the correct position relevant to the menu item
        submenuWrapper.css({
          top: menuItemPos.top + Math.round(menuItem.outerHeight() + 1 + adminBarHeight),
          left: menuItemPos.left,
        });
      });

      if (helpers.isMobile()) {
        const submenu = $('.sub-menu');
        if (submenu.length) {
          submenu.each(function () {
            const link = $(this).siblings('a');

            link.on('click', function (e) {
              e.preventDefault();
            });
          });
        }
      }
    }

    // Header notifications
    const headerNotificationsWrapper = $('.header-notifications-wrapper');

    if (headerNotificationsWrapper.length) {
      const headerNotificationsCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_HEADER_NOTIFICATIONS_EXPIRY);

      if (!headerNotificationsCookie) {
        // add class to body
        body.addClass('with-header-notification');

        const notifClose = headerNotificationsWrapper.find('.notif-close');
        if (notifClose.length) {
          notifClose.on('click', function(e) {
            e.preventDefault();

            const cookieExpiry = notifClose.data('cookie-expiry');

            headerNotificationsWrapper.remove();

            helpers.docCookies.setItem(constants.COOKIE_KEY_HEADER_NOTIFICATIONS_EXPIRY, 1, cookieExpiry * 86400, '/');

            // remove class from body when notification is closed
            body.removeClass('with-header-notification');
            setNotifBarHeight();
          });
        }

        // Header notifications slider
        const swiperContainer = headerNotificationsWrapper.find('.swiper-container');
        const notificationSlide = headerNotificationsWrapper.find('.notification-slide');
        let autoplay = false;

        if (notificationSlide.length > 1) {
          autoplay = {
            delay: headerNotificationsWrapper.data('autoplay-speed'),
            disableOnInteraction: false,
          };
        }

        new Swiper(swiperContainer.get(0), {
          slidesPerView: 1,
          direction: 'vertical',
          loop: true,
          autoplay: autoplay,
        });

        /**
         * Used for setting equal heights...
         * helpers.js equal height considers row and does not work well
         * with this as this is a vertical slide and have varying position tops
         */
        const notifItems = headerNotificationsWrapper.find('.notification-item-wrapper');
        let tallestHeight = 0;

        // Get tallest height
        notifItems.each((index, item) => {
          if (tallestHeight < $(item).height()) {
            tallestHeight = $(item).height();
          }
        });

        // Set tallest height
        swiperContainer.height(tallestHeight);
        notifItems.each((index, item) => {
          $(item).height(tallestHeight);
        });

        // set :root css variable --notif-bar-height with headerNotificationsWrapperHeight
        setNotifBarHeight();

        // // NOTE: Fix for chrome's wrong outerHeight value
        setTimeout (function () {
          if (body.hasClass('admin-bar')) {
            helpers.adminBarHeight();
          }
        }, 1);
      } else {
        headerNotificationsWrapper.remove();
      }

      body.on('click', '.evt-stays-member-dropdown', function() {
        setNotifBarHeight();
      });
    }

    function setNotifBarHeight() {
      const headerNotificationsWrapperHeight = headerNotificationsWrapper.outerHeight();

      // set root css variable --notif-bar-height with headerNotificationsWrapperHeight
      r.style.setProperty('--notif-bar-height', `${headerNotificationsWrapperHeight}px`);
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/modules/header.js